(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-variant-link-sync"]) return;
  try {
    
  class CampaignVariantLinkSync extends HTMLElement {
    connectedCallback() {
      this.grid = document.querySelector('section-variant-grid');
      if (!this.grid) return;

      this.syncLinks = () => {
        this.grid.querySelectorAll('.product-card').forEach((card) => {
          const variantLink = card.querySelector('.product-card__images[href*="variant="]');
          const titleLink = card.querySelector('.product-card__url');

          if (variantLink && titleLink && titleLink.href !== variantLink.href) {
            titleLink.href = variantLink.href;
          }
        });
      };

      this.observer = new MutationObserver(this.syncLinks);
      this.observer.observe(this.grid, {
        attributes: true,
        attributeFilter: ['href'],
        childList: true,
        subtree: true,
      });
      this.syncLinks();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('campaign-variant-link-sync')) {
    customElements.define('campaign-variant-link-sync', CampaignVariantLinkSync);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relaxation-day-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.relaxationInitialized === 'true') return;
      root.dataset.relaxationInitialized = 'true';

      const reveals = root.querySelectorAll('.rd26__reveal');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      root.querySelectorAll('[data-product-rail]').forEach((rail) => {
        const track = rail.querySelector('[data-product-track]');
        const previous = rail.querySelector('[data-rail-previous]');
        const next = rail.querySelector('[data-rail-next]');
        const status = rail.querySelector('[data-rail-status]');
        const products = Array.from(rail.querySelectorAll('.rd26__product'));

        if (!track || !previous || !next || !status || products.length === 0) return;

        let ticking = false;

        const updateRail = () => {
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const firstWidth = products[0].getBoundingClientRect().width;
          const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          const activeIndex = Math.min(
            products.length,
            Math.max(1, Math.round(track.scrollLeft / (firstWidth + gap)) + 1)
          );

          previous.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft >= maxScroll - 4;
          status.textContent = `${String(activeIndex).padStart(2, '0')} / ${String(products.length).padStart(2, '0')}`;
          ticking = false;
        };

        const moveRail = (direction) => {
          track.scrollBy({
            left: direction * track.clientWidth * 0.86,
            behavior: reducedMotion ? 'auto' : 'smooth'
          });
        };

        previous.addEventListener('click', () => moveRail(-1));
        next.addEventListener('click', () => moveRail(1));
        track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          moveRail(event.key === 'ArrowRight' ? 1 : -1);
        });
        track.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(updateRail);
          },
          { passive: true }
        );

        if ('ResizeObserver' in window) {
          const railObserver = new ResizeObserver(updateRail);
          railObserver.observe(track);
        }

        updateRail();
      });

      if (reducedMotion || !('IntersectionObserver' in window)) {
        reveals.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );

      reveals.forEach((item) => observer.observe(item));
    };

    document.querySelectorAll('[data-relaxation-2026]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-relaxation-2026]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
